export default {
  "debug": false,
  "eventCategory": "Web Vitals",
  "id": "G-3V4DPBY0RC"
}